import React from "react";
import { FIELD_STATE } from "../../utils";

const COL_SPAN_CLASS = {
  3: "col-span-3",
  4: "col-span-4",
  6: "col-span-6",
  8: "col-span-8",
  9: "col-span-9",
  12: "col-span-12",
};

export const Field = ({ label, span = 6, dataFocusField, trailing, fieldState, hidden, children }) => {
  if (hidden) return null;
  if (fieldState === FIELD_STATE.DISABLE) return null;
  return (
    <div className={COL_SPAN_CLASS[span] || "col-span-6"} data-focus-field={dataFocusField}>
      <div className="field-label mb-0.5 flex items-center gap-1.5">
        <span>{label}</span>
        {trailing}
      </div>
      {children}
    </div>
  );
};

export const FieldGrid = ({ children }) => <div className="grid grid-cols-12 gap-x-3 gap-y-1">{children}</div>;

const hasVisibleChild = (node) => {
  if (node === null || node === undefined || node === false) return false;
  if (Array.isArray(node)) return node.some(hasVisibleChild);
  if (typeof node !== "object") return true;
  if (React.isValidElement(node)) {
    if (node.type === React.Fragment) return hasVisibleChild(node.props.children);
    if (node.type === Field) {
      if (node.props.hidden) return false;
      if (node.props.fieldState === FIELD_STATE.DISABLE) return false;
      return true;
    }
    if (node.props && "children" in node.props) return hasVisibleChild(node.props.children);
    return true;
  }
  return true;
};

export const FieldGroup = ({ children }) => {
  if (!hasVisibleChild(children)) return null;
  return <div className="mb-3 border-b border-gray-100 pb-3 last:mb-0 last:border-b-0 last:pb-0">{children}</div>;
};
